import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableComponent } from '../../shared/components/table/table.component';
import { VisationService } from '../../core/services/visation.service';
import { Visation } from '../../core/models/visation.model';
import { TableColumn } from '../../core/models/column.model';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-approval-notifications',
  templateUrl: './approval-notifications.component.html',
  styleUrls: ['./approval-notifications.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    TableComponent,
    MatPaginatorModule,
    MatSortModule,
    MatTableModule,
    RouterModule,
  ],
})
export class ApprovalNotificationsComponent implements OnInit {
  visations: Visation[] = [];
  flattenedData: any[] = [];

  tableColumns: TableColumn[] = [
    { header: 'Nº', field: 'id' },
    { header: 'Mantención', field: 'maintenanceType' },
    { header: 'Tipo envase', field: 'containerTypeName' },
    { header: 'Solicitante', field: 'username' },
    { header: 'Tipo cambio', field: 'changeType' },
    { header: 'F. cambio', field: 'effectiveDate', isDate: true },
    { header: 'F. solicitud', field: 'requestedDate', isDate: true },
    // { header: 'Acciones', field: 'actions' },
  ];

  constructor(private visationService: VisationService) {}

  ngOnInit(): void {
    this.getVisations();
  }

  getVisations(): void {
    this.visationService.getVisationActionsByAction('Pendiente').subscribe({
      next: (visations: Visation[]) => {
        this.visations = visations;
        this.flattenData();
      },
      error: error => {
        console.error('Error al obtener las visaciones:', error);
      },
    });
  }

  flattenData(): void {
    this.flattenedData = this.visations.map((item: Visation) => ({
      id: item.id,
      maintenanceType: item.maintenance?.maintenanceType?.name || '',
      containerTypeName: item.maintenance?.typeContainer?.name || '',
      username: item.requestingUser?.username || '',
      changeType: item.changeType,
      effectiveDate: item.effectiveDate,
      requestedDate: item.requestedDate,
      status: item.status,
      action: item.action?.name,
    }));
  }

  approve(visation: Visation): void {
    console.log('Aprobado:', visation);
  }

  reject(visation: Visation): void {
    console.log('Rechazado:', visation);
  }

  return(visation: Visation): void {
    console.log('Devuelto:', visation);
  }
}
